import { Provider } from '@angular/core';
import { DataHttpService } from './data-http.service';

export const DataHttpServiceProvider: Provider = {
	provide: DataHttpService,
	useClass: DataHttpService,
};
